import { default as FormattedHTMLMessage } from 'I18n/components/FormattedHTMLMessage';
import Products from 'merchandise-lib/constants/Product';
import { default as FormattedMessage } from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Button } from 'foundations-components/transitional/components/Button';
import { getHubAndTierFromApiName, isCommerceHub } from '../../../utils/product';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Welcome = ({
  apiName
}) => {
  switch (apiName) {
    case Products.CRM_SUITE_STARTER_BUNDLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.crm-suite-starter-bundle"
      });
    case Products.CMS_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.cms-hub-professional"
      });
    case Products.CMS_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.cms-hub-enterprise"
      });
    case Products.MARKETING_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.marketing-hub-professional"
      });
    case Products.MARKETING_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.marketing-hub-enterprise"
      });
    case Products.OPERATIONS_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.operations-hub-professional"
      });
    case Products.OPERATIONS_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.operations-hub-enterprise"
      });
    case Products.SALES_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.sales-hub-professional"
      });
    case Products.SALES_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.sales-hub-enterprise"
      });
    case Products.SERVICE_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.service-hub-professional"
      });
    case Products.SERVICE_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.service-hub-enterprise"
      });
    case Products.COMMERCE_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.commerce-hub-professional"
      });
    case Products.COMMERCE_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.commerce-hub-enterprise"
      });
    case Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.marketing-plus-professional-bundle"
      });
    case Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.welcome.marketing-plus-enterprise-bundle"
      });
    default:
      return null;
  }
};
const productFeatures = ({
  apiName
}) => {
  switch (apiName) {
    case Products.CMS_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.cms-hub-professional"
      }, "cms-hub-professional")];
    case Products.CMS_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.cms-hub-enterprise"
      }, "cms-hub-enterprise")];
    case Products.MARKETING_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.marketing-hub-professional"
      }, "marketing-hub-professional")];
    case Products.MARKETING_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.marketing-hub-enterprise"
      }, "marketing-hub-enterprise")];
    case Products.OPERATIONS_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.operations-hub-professional"
      }, "operations-hub-professional")];
    case Products.OPERATIONS_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.operations-hub-enterprise"
      }, "operations-hub-enterprise")];
    case Products.SALES_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.sales-hub-professional"
      }, "sales-hub-professional")];
    case Products.SALES_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.sales-hub-enterprise"
      }, "sales-hub-enterprise")];
    case Products.SERVICE_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.service-hub-professional"
      }, "service-hub-professional")];
    case Products.SERVICE_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.service-hub-enterprise"
      }, "service-hub-enterprise")];
    case Products.COMMERCE_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.commerce-hub-professional"
      }, "commerce-hub-professional")];
    case Products.COMMERCE_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.commerce-hub-enterprise"
      }, "commerce-hub-enterprise")];
    case Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.cms-hub-professional"
      }, "cms-hub-professional"), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.marketing-hub-professional"
      }, "marketing-hub-professional")];
    case Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.cms-hub-enterprise"
      }, "cms-hub-enterprise"), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.trial.trialActivationModal.features.marketing-hub-enterprise"
      }, "marketing-hub-enterprise")];
    default:
      return [];
  }
};
export const ActivationSuccessModal = ({
  apiName,
  onStartSuccess,
  showTrialLoadingState,
  featureDisplayName,
  onClose
}) => {
  const hubAndTier = getHubAndTierFromApiName(apiName);
  const tier = hubAndTier.tier.toUpperCase();
  const hub = hubAndTier.hub;
  const handleRedirectButtonClick = () => {
    onStartSuccess();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    use: "success",
    width: 466,
    "data-test-id": "activation-success-modal",
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: 10,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: featureDisplayName && !isCommerceHub(hub) ? 'errors/map' : 'setup-complete',
        width: 118
      })
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      marginBlock: "0",
      paddingBlockStart: "0",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-600",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(Welcome, {
          apiName: apiName
        })
      }), onClose && /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      textAlign: "left",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [apiName === Products.CRM_SUITE_STARTER_BUNDLE ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "purchaseMotions.trial.trialActivationModal.featureListHeadStarterCustomerPlatform"
        }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "purchaseMotions.trial.trialActivationModal.featureListHead"
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          wrapChildren: true,
          listStylePosition: "outside",
          children: [productFeatures({
            apiName
          }), tier === 'PROFESSIONAL' && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.trialActivationModal.features.trialGuide"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.trialActivationModal.features.support"
          }), tier === 'PROFESSIONAL' && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.trialActivationModal.features.includesStarter"
          }), tier === 'ENTERPRISE' && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.trialActivationModal.features.includesProfessional"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(List, {
        marginBlockEnd: "300",
        children: showTrialLoadingState ? /*#__PURE__*/_jsx(LoadingSpinner, {
          showLabel: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.trialActivationModal.loadingLabel"
          })
        }) : /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "body-125",
            children: featureDisplayName && !isCommerceHub(hub) ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "purchaseMotions.trial.trialActivationModal.footerWithFeature",
              options: {
                feature: featureDisplayName
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.trial.trialActivationModal.footer"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "600",
            inlineSize: "170px",
            children: /*#__PURE__*/_jsx(Button, {
              block: true,
              use: "primary",
              onClick: handleRedirectButtonClick,
              children: featureDisplayName ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.trial.trialActivationModal.getStarted"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.trial.trialActivationModal.redirectButton"
              })
            })
          })]
        })
      })
    })]
  });
};